import React, {useCallback} from 'react';
import {Platform, StyleProp, StyleSheet, TextStyle, TouchableOpacity, View, ViewStyle} from 'react-native';
import {useStyles} from '../../../../hooks/styles';
import {Text} from '../../../text';

export interface RadioProps {
  onChange?(val: boolean): any;
  checked: boolean | undefined;
  label?: string;
  labelStyle?: StyleProp<TextStyle>;
  disabled?: boolean;
  wrapExtraStyles?: ViewStyle;
  value: any;
}

export default ({labelStyle, value, checked, onChange, label, wrapExtraStyles, disabled}: RadioProps) => {
  const styles = useStyles(
    ({theme}) => {
      const color = disabled
        ? theme.color.nonActiveCheckBoxColor
        : checked
        ? theme.color.primaryColor
        : theme.color.textColor;
      return {
        activeColor: {
          color: theme.color.primaryColor,
        },
        nonActiveColor: {
          color: theme.color.textColor,
        },
        disabledColor: {
          color: theme.color.nonActiveCheckBoxColor,
        },
        wrap: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        },
        radio: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: 20,
          height: 20,
          borderRadius: 10,
          borderWidth: 2,
          borderColor: color,
          borderStyle: 'solid',
          opacity: checked ? 1 : 0.54,
          color,
        },
        radioIndicator: {
          width: 10,
          height: 10,
          borderRadius: 5,
          opacity: checked ? 1 : 0,
          backgroundColor: color,
        },
        label: {
          ...theme.fonts.label,
          paddingLeft: 11,
        },
      };
    },
    [checked],
  );

  const handlePress = useCallback(() => {
    if (onChange) {
      onChange(value);
    }
  }, [onChange, checked, value]);

  return (
    <TouchableOpacity
      testID={`basefield-radio-${label}`}
      disabled={disabled}
      activeOpacity={Platform.OS === 'web' ? 1 : 0.5}
      style={StyleSheet.flatten([styles.wrap, wrapExtraStyles])}
      onPress={handlePress}>
      <View style={styles.radio}>
        <View style={styles.radioIndicator} />
      </View>
      {label ? <Text style={[styles.label, labelStyle]}>{label}</Text> : null}
    </TouchableOpacity>
  );
};
